import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء
const api = axios.create({
  baseURL: API_BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//   },
});

// دالة لجلب شروحات النظام
export const getSystemExplanations = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`get/system/explanations?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// دالة لجلب صور شروحات النظام
export const getSystemExplanationImages = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`get/explanation/images?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// دالة لجلب فيديوهات شروحات النظام
export const getSystemExplanationVideos = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`get/explanation/videos?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// دالة لجلب الخطط المتوفرة
export const getAvailablePlans = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`get/plane?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// دالة لإنشاء شرح جديد للنظام
export const createSystemExplanation = (formData) => {
  const token = localStorage.getItem("authToken");
  console.log(localStorage.getItem("authToken"))

  return axios.post(
    `${API_BASE_URL}create/system/explanation?api_password=${API_PASSWORD}`,
    
    formData,
    
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
      
    }
  );
  
};

// 🟢 دالة لتحديث شرح النظام
export const updateSystemExplanation = (id, formData) => {
  const token = localStorage.getItem("authToken");

  console.log("🛠 Updating system explanation ID:", id);
  console.log("🔑 Auth Token:", token);

  return axios.post(
    `${API_BASE_URL}update/system/explanation/${id}?api_password=${API_PASSWORD}`,
    formData,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// 🟢 دالة لحذف شرح النظام
export const deleteSystemExplanation = (id) => {
  const token = localStorage.getItem("authToken");
  return axios.get(
    `${API_BASE_URL}delete/system/explanation/${id}?api_password=${API_PASSWORD}`,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    }
  );
};


// 🟢 دالة لإرفاق صور إلى شرح النظام
// 🟢 دالة لإرفاق صور إلى شرح النظام (إصلاح كامل)
export const attachImagesToExplanation = async (explanationId, imagesData) => {
  const token = localStorage.getItem("authToken");

  console.log("🖼️ Attaching images to explanation ID:", explanationId);
  console.log("🔑 Token:", token);

  if (!token) {
    alert("⚠️ لا يوجد توكن، يرجى تسجيل الدخول أولاً.");
    return Promise.reject("Token not found");
  }

  try {
    const response = await fetch(
      `${API_BASE_URL}attach/images/to/explanation/${explanationId}?api_password=${API_PASSWORD}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // ✅ إرسال التوكن يدوياً بدون تدخل axios
        },
        body: imagesData, // ✅ أرسل الـ FormData مباشرة
      }
    );

    const result = await response.json();

    if (!response.ok) {
      console.error("❌ Error uploading images:", result);
      throw new Error(result.error || "فشل رفع الصور");
    }

    console.log("✅ Images uploaded successfully:", result);
    return result;
  } catch (error) {
    console.error("🚨 Upload failed:", error);
    throw error;
  }
};



// 🟢 دالة لتحديث صورة شرح النظام
export const updateExplanationImage = (imageId, formData) => {
  const token = localStorage.getItem("authToken");

  console.log("🖼️ Updating explanation image ID:", imageId);
  console.log("🔑 Auth Token:", token);

  return axios.post(
    `${API_BASE_URL}update/explanation/image/${imageId}?api_password=${API_PASSWORD}`,
    formData,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// 🗑️ دالة لحذف صورة شرح النظام
export const deleteExplanationImage = (imageId) => {
  const token = localStorage.getItem("authToken");

  console.log("🗑️ Deleting explanation image ID:", imageId);
  console.log("🔑 Auth Token:", token);

  return axios.get(
    `${API_BASE_URL}delete/explanation/image/${imageId}?api_password=${API_PASSWORD}`,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    }
  );
};



// 🟢 دالة لإرفاق فيديوهات إلى شرح النظام
export const attachVideosToExplanation = (explanationId, videosData) => {
  const token = localStorage.getItem("authToken");

  console.log("🎥 Attaching videos to explanation ID:", explanationId);
  console.log("🔑 Token:", token);

  return axios.post(
    `${API_BASE_URL}attach/videos/to/explanation/${explanationId}?api_password=${API_PASSWORD}`,
    videosData,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
        // ⚠️ لا تضيف Content-Type لأن axios سيضبطها تلقائيًا
      },
    }
  );
};

// 🗑️ دالة لحذف فيديو من شرح النظام
export const deleteExplanationVideo = (videoId) => {
  const token = localStorage.getItem("authToken");

  console.log("🗑️ Deleting explanation video ID:", videoId);
  console.log("🔑 Token:", token);

  return axios.get(
    `${API_BASE_URL}delete/explanation/video/${videoId}?api_password=${API_PASSWORD}`,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    }
  );
};


// 🟢 دالة لتحديث فيديو شرح النظام
export const updateExplanationVideo = (videoId, formData) => {
  const token = localStorage.getItem("authToken");

  console.log("🎬 Updating explanation video ID:", videoId);
  console.log("🔑 Auth Token:", token);

  if (!token) {
    console.error("⚠️ No token found in localStorage.");
    return Promise.reject("Token not found");
  }

  return axios.post(
    `${API_BASE_URL}update/explanation/video/${videoId}?api_password=${API_PASSWORD}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
